<script>
import mixins from '../apimixins'
import api from '@utils/api'
import TablePaginator from '@components/paginator'
import cloneDeep from 'lodash/cloneDeep'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'UnresponsiveTransmittersAndPlugs',
  components: {
    AdjustColumnsDialog,
    TablePaginator,
  },
  mixins: [mixins],
  props: {
    extParams: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      modelName: 'UnresponsiveTransmittersAndPlugs',
      showDialog: false,
      headers: [
        { text: 'type', value: 'typeName', sortable: true },
        { text: 'serial', value: 'serial', sortable: true },
        {
          text: 'last_known_place',
          value: 'organisation',
          sortable: true,
          hide: false,
          show: true,
        },
        {
          text: 'last_message_date',
          value: 'lastMessageDate',
          sortable: true,
          hide: false,
          show: true,
        },
      ],
      daysNoResponse: 10,
      isLoading: false,
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  mounted() {
    let settingsFromStore = this.getSettingsFromStore()
    if (settingsFromStore) {
      this.daysNoResponse = settingsFromStore
    }
    this.init()
  },
  methods: {
    submit() {
      this.resetPage()
      this.getDataSet()
    },
    async init() {
      if (this.extParams) {
        this.otherParams = this.extParams
      }
      this.loading = true
      this.setSettingsInStore()
      this.getPaginator()
      let filters = this.getFilters()
      if (this.filtersEmpty(filters)) {
        this.getDataSet()
      }
    },
    getDataSet() {
      this.isLoading = true
      this.otherParams = { days_no_response: this.daysNoResponse }
      this.setSettingsInStore()
      this.prepareFilterParams()
      api.getReportData('unresponsive_devices', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content
        this.isLoading = false
      })
    },
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.daysNoResponse),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
  },
}
</script>

<template>
  <div>
    <v-container
      v-show="!extParams"
      fluid
      grid-list-xs
    >
      <v-layout row>
        <v-flex md2>
          <v-text-field
            v-model.number="daysNoResponse"
            :label="$t('label__not_responsible_days')"
            type="number"
          />
        </v-flex>
        <v-flex md2>
          <v-btn
            color="primary"
            @click="submit()"
          >
            {{ $t('buttons__apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>{{ $t(`goodsgroup.${props.item.type}.name`) }}</td>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.serial, goodsGroup: props.item.type }} "> {{ props.item.serial }}
            </router-link>
            <span v-else>{{ props.item.serial }}</span>
          </td>
          <td v-if="!hideValues('organisation')">
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '' }}</span>
          </td>
          <td v-if="!hideValues('lastMessageDate')">{{ props.item.lastMessageDate ? dateFormat(props.item.lastMessageDate) : '' }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
